import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create Class
export const referCourse = data => post(url.REFER_COURSE, data);
export const getReferralByUser = data => post(url.GET_REFERRAL_BY_USER, data);